var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.633 10.681c-1.202 0-2.177-.954-2.177-2.13 0-1.177.975-2.13 2.177-2.13 1.203 0 2.178.953 2.178 2.13 0 1.176-.975 2.13-2.178 2.13zm0 1.42c1.97 0 3.585-1.58 3.585-3.55C12.218 6.58 10.603 5 8.633 5S5.05 6.58 5.05 8.55c0 1.972 1.614 3.551 3.584 3.551zM2 18.188c0 .449.36.812.804.812a.808.808 0 0 0 .804-.812v-1.014c0-1.233.99-2.232 2.211-2.232h5.528c1.22 0 2.21 1 2.21 2.232v1.014c0 .449.36.812.805.812a.808.808 0 0 0 .804-.812v-1.014c0-2.13-1.71-3.855-3.82-3.855H5.82C3.71 13.319 2 15.045 2 17.174v1.014zm15.678-8.116a1.515 1.515 0 0 1-1.507-1.521c0-.84.675-1.522 1.507-1.522.833 0 1.508.681 1.508 1.522 0 .84-.675 1.521-1.508 1.521zm0 1.218c1.5 0 2.714-1.226 2.714-2.74 0-1.512-1.215-2.738-2.714-2.738-1.498 0-2.713 1.226-2.713 2.739s1.215 2.739 2.713 2.739zm-2.311 1.014a.808.808 0 0 0-.804.812c0 .448.36.812.804.812h3.75c.704 0 1.275.576 1.275 1.287v.944c0 .449.36.812.804.812a.808.808 0 0 0 .804-.812v-.944c0-1.608-1.29-2.91-2.883-2.91h-3.75z",
    fill: "#C5CEE0",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.ae858855.svg";
export { ForwardRef as ReactComponent };